import api from '../../utils/api';

export interface DailyApiMetric {
  date: string;
  endpoint: string;
  total_requests: number;
  error_rate: number;
  avg_response_time: number;
  p95_response_time: number;
}

export interface DailyErrorMetric {
  date: string;
  error_type: string;
  total_occurrences: number;
  unique_users: number;
}

export interface ObservabilityDailyResponse {
  success: boolean;
  data: {
    from: string;
    to: string;
    apiRows: DailyApiMetric[];
    errorRows: DailyErrorMetric[];
  };
}

export interface ActorDashboardResponse {
  success: boolean;
  data: {
    from: string;
    to: string;
    apiSummary: {
      total_calls: number;
      failed_calls: number;
      avg_latency_ms: number;
      p95_latency_ms: number;
    } | null;
    topEndpoints: Array<{
      endpoint: string;
      method: string;
      total_calls: number;
      failed_calls: number;
      avg_latency_ms: number;
    }>;
    errorSummary: Array<{
      error_type: string;
      total_occurrences: number;
      latest_message: string;
    }>;
  };
}

export async function fetchDailyObservabilityMetrics(params?: {
  from?: string;
  to?: string;
  limit?: number;
}): Promise<ObservabilityDailyResponse> {
  const response = await api.get('/master-admin/analytics/daily-metrics', { params });
  return response.data;
}

export async function fetchActorObservabilityDashboard(
  actorId: string,
  params?: { from?: string; to?: string }
): Promise<ActorDashboardResponse> {
  const response = await api.get(`/master-admin/analytics/actors/${encodeURIComponent(actorId)}/dashboard`, {
    params,
  });
  return response.data;
}
